module.exports = __webpack_public_path__ + "14four/static/media/RotateArt.a961e92f.png";